import Vue from 'vue'

import { querySelectorAsync } from '@/utils/querySelectorAsync';

export async function getStyles (elOrSelector) {
  await Vue.nextTick();

  const el =
    typeof elOrSelector === 'string'
      ? await querySelectorAsync(elOrSelector)
      : elOrSelector;

  return window.getComputedStyle(el);
}